import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Achievement } from '@app/model/achievement';
import { AchievementTypeEnum } from '@app/model/enums/achievement-type.enum';
import { AchievementModalComponent } from '../achievement-modal/achievement-modal.component';
import { BadgeCouponApiService } from '@app/services/api/badge-coupon-api.service';
import { BadgeCouponCode } from '@app/model/badge-coupon-code';

@Component({
    selector: 'app-achievement-card',
    templateUrl: './achievement-card.component.html',
    styleUrls: ['./achievement-card.component.scss'],
    standalone: false
})
export class AchievementCardComponent implements OnInit {

  @Input() achievement: Achievement;

  public AchievementTypeEnum = AchievementTypeEnum;
  public progress = 0;
  public coupon: BadgeCouponCode;

  constructor(
    private readonly dialog: MatDialog,
    private readonly badgeCouponApiService: BadgeCouponApiService
  ) { }

  ngOnInit(): void {
    this.progress = this.achievement.achievementType === AchievementTypeEnum.QUANTITIVE
      ? (this.achievement.numberOfCompletedContents / this.achievement.numberOfContents) * 100
      : 0;
    
    this.loadBadgeCode();
  }

  public openModal() {
    this.dialog.open(AchievementModalComponent, {
      disableClose: false,
      panelClass: ['mobile-full-width-dialog', 'dialog-no-padding', 'dialog-no-margin'],
      width: '500px',
      closeOnNavigation: true,
      restoreFocus: false,
      data: {...this.achievement}
    });
  }
  
  private loadBadgeCode(): void {
    if (!this.achievement.couponId || !this.achievement.achieved) {
      return;
    }

    this.badgeCouponApiService.getBadgeCouponCodeCollection(this.achievement.id).subscribe(data => {
      this.coupon = data['hydra:member']?.[0]
    });
  }

}
